var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sleep, to } from "@lib/utils";
import { ParticleNetwork } from "@particle-network/auth";
import * as Sentry from "@sentry/browser";
import { isEmpty } from "lodash";
import { isMobile, isSafari } from "../../wallet";
import { useUserStore } from "./auth";
const PARTICLE_PROJECT_ID = process.env.NEXT_PUBLIC_PARTICLE_PROJECT_ID || "";
if (!PARTICLE_PROJECT_ID)
    throw "Missing NEXT_PUBLIC_PARTICLE_PROJECT_ID";
const PARTICLE_CLIENT_KEY = process.env.NEXT_PUBLIC_PARTICLE_CLIENT_KEY || "";
if (!PARTICLE_CLIENT_KEY)
    throw "Missing NEXT_PUBLIC_PARTICLE_CLIENT_KEY";
const PARTICLE_APP_ID = process.env.NEXT_PUBLIC_PARTICLE_APP_ID || "";
if (!PARTICLE_APP_ID)
    throw "Missing NEXT_PUBLIC_PARTICLE_APP_ID";
let PARTICLE;
export const initParticleNetwork = () => {
    if (PARTICLE)
        return PARTICLE;
    PARTICLE = new ParticleNetwork({
        projectId: PARTICLE_PROJECT_ID,
        clientKey: PARTICLE_CLIENT_KEY,
        appId: PARTICLE_APP_ID,
        chainName: "Ethereum",
        chainId: 1,
        wallet: {
            displayWalletEntry: false,
            supportChains: [
                { id: 1, name: "Ethereum" },
                { id: 137, name: "Polygon" },
                { id: 43114, name: "Avalanche" },
            ],
            customStyle: {}, //optional: custom wallet style
        },
    });
    return PARTICLE;
};
const loginParticleWallet = (idToken) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "loginParticleWallet",
        level: "info",
    });
    idToken = idToken || useUserStore.getState().idToken;
    if (!idToken)
        return null;
    const pn = initParticleNetwork();
    console.log("loginParticleWallet", pn, idToken);
    if (isMobile() || isSafari())
        yield sleep(1);
    const { err, res } = yield to(pn.auth.login({
        preferredAuthType: "jwt",
        account: idToken,
        hideLoading: true,
    }), 120);
    if (err || !res || isEmpty(res.wallets)) {
        Sentry.captureException(err);
        console.log("loginParticleWallet", err);
        return null;
    }
    console.log("loginParticleWallet", res);
    return res.wallets;
});
export const getParticleWallet = (idToken) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const wallets = yield loginParticleWallet(idToken);
    if (!wallets)
        return "";
    return ((_a = wallets.find((w) => w.chain_name == "evm_chain")) === null || _a === void 0 ? void 0 : _a.public_address) || "";
});
export const openParticleWallet = () => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "openParticleWallet",
        level: "info",
    });
    const pn = initParticleNetwork();
    console.log(pn.auth.isLogin());
    if (!pn.auth.isLogin())
        yield loginParticleWallet();
    return pn.openWallet();
});
